import { api } from "../../../utils/api";

export const getLeads = async (data) => {
  try {
    const response = await api.get(`/lead`, {params: data});
    return response.data;
  } catch (error) {
    throw error;
  }
}